export const BADGE_ICONS: Record<string, string> = {
  as_described: "✓",
  well_packaged: "📦",
  fast_shipping: "⚡",
  great_communication: "💬",
  not_as_described: "⚠️",
  poor_packaging: "📦",
  slow_shipping: "🐢",
  poor_communication: "💬",
  damaged_item: "❌",
  fast_payment: "€",
  patient: "🕐",
  clear_communication: "💬",
  good_faith: "🤝",
  responsive: "⚡",
  slow_payment: "€",
  impatient: "🕐",
  rude_communication: "💬",
  bad_faith: "🤝",
  unresponsive: "⚡",
  disrespectful: "⚠️",
};
